module.exports = __tmimport("~endpoint:{controller: \'customized/api\', action: \'list_payment_methods\'}");